// Eine Wahrheit für die Status-Beschriftung (DRY: Board + Detail teilen sie).
export const STATUS_LABEL: Record<string, string> = {
  offen: 'Offen',
  arbeit: 'In Arbeit',
  wartet: 'Wartet',
  fertig: 'Fertig',
  abgeholt: 'Abgeholt',
}

// Prioritäts-Optionen für Auswahlfelder (Anlage-Wizard + Detail-Bearbeiten teilen sie). Die Karten-Badge
// nutzt bewusst eine eigene ALLCAPS-Beschriftung (OrderCard.PRIO_LABEL) — andere Darstellung, anderer Ort.
export const PRIO_OPTIONS = [
  { value: 'hoch', label: 'Hoch' },
  { value: 'mittel', label: 'Mittel' },
  { value: 'niedrig', label: 'Niedrig' },
] as const
